var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GalleryFormGroup',{attrs:{"value":_vm.value.image_id,"name":"image_id","label":"Image","error":(_vm.errors.image_id || [])[0]},on:{"input":function($event){return _vm.emit('image_id', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }